import React, {Component} from 'react'
import {withApollo} from '@apollo/client/react/hoc'
import {ApolloProvider} from '@apollo/client'
import {apolloCache} from '../apollo'

const withCacheClient = (WrappedComponent, ttl = 10) => {
  const WrappedComponentWithApollo = withApollo(WrappedComponent)

  return class ApolloCacheClientProvider extends Component {
    render() {
      return (
        <ApolloProvider client={apolloCache.getClient(ttl)}>
          <WrappedComponentWithApollo {...this.props}/>
        </ApolloProvider>
      )
    }
  }
}

export default withCacheClient
